/**
 * Geolop Asistanı EFEKTLERİ — (1) sesli mod aktifken ekran kenarlarında canlı ışıma
 * (Claude'un "kontrol bende" animasyonu gibi; renk orb durumunu izler),
 * (2) asistan kullanıcıyı bir sayfaya götürdüğünde hedef kartı bulup vurgulama.
 */
import { useEffect } from "react";
import { useAssistantStore, assistantStore } from "@/lib/assistant-store";

const EDGE_COLOR: Record<string, string> = {
  idle: "245,158,11",      // amber
  thinking: "139,92,246",  // mor
  speaking: "245,158,11",  // amber
  listening: "34,211,238", // camgöbeği
};

export function AssistantEffects() {
  const { voice, orb, highlight } = useAssistantStore();

  // Ekranda vurgulama: navigasyon sonrası hedef kartı başlık metniyle bul, işaretle
  useEffect(() => {
    if (!highlight) return;
    const q = highlight.toLocaleLowerCase("tr").trim();
    let cleared = false;
    const timer = window.setTimeout(() => {
      const candidates = Array.from(document.querySelectorAll<HTMLElement>(
        "h1,h2,h3,h4,th,[class*='font-semibold'],[class*='font-bold'],[class*='CardTitle']",
      ));
      const el = candidates.find((c) => c.offsetParent !== null && (c.textContent ?? "").toLocaleLowerCase("tr").includes(q));
      // Kartın tamamını vurgula: en yakın Card sarmalayıcı; yoksa elemanın kendisi
      const target = el?.closest<HTMLElement>("[class*='rounded-lg'],[class*='rounded-xl'],[class*='card']") ?? el ?? null;
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "center" });
        target.classList.add("assistant-highlight");
        window.setTimeout(() => { target.classList.remove("assistant-highlight"); }, 6000);
      }
      if (!cleared) { cleared = true; assistantStore.setHighlight(null); }
    }, 1000); // sayfanın render olması için kısa bekleme
    return () => { window.clearTimeout(timer); if (!cleared) assistantStore.setHighlight(null); };
  }, [highlight]);

  if (!voice) return null;
  const rgb = EDGE_COLOR[orb] ?? EDGE_COLOR.idle;
  return (
    <div aria-hidden className="assistant-edge" style={{ ["--assistant-rgb" as never]: rgb }} />
  );
}
